// https://easings.net/
export default class Easing {
    static Bezier = (t: number) => t * t * (3 - 2 * t)
    static Sine = (t: number) => -(Math.cos(Math.PI * t) - 1) / 2
    static InSine = (t: number) => 1 - Math.cos((t * Math.PI) / 2)
    static EaseOutExpo = (t: number) => t === 1 ? 1 : 1 - Math.pow(2, -10 * t)
    static EaseOutQuart = (t: number) => 1 - Math.pow(1 - t, 4);
}